import { API } from '@Providers';
interface AddDiscountPayload {
  // TODO :: TASK-980 unify and sanitize interface and apply it do addCartItemDiscount.service
  code: string;
  item_id: string;
  target_item: string; // TODO :: TASK-980 Replace this for enum that matches the one in the API
}

export default async function (payload: AddDiscountPayload) {
  const endpoint = '/api/shelter/cart/remove-item-discount/';

  return API({ endpoint, method: 'delete', payload });
}
